<template>
  <div id="app">
    <div class="container" v-if="!loading">
        <v-style>
          .btn-primary.active, .spinner-border{
            color: {{this.settings.widgetMainButtonBackground}} !important;
          }
          .btn-primary.active{
            color: {{this.settings.widgetMainButtonColor}} !important
          }
          .btn-primary, .bg-primary {
            background-color: {{this.settings.widgetMainButtonBackground}} !important;
            border-color:{{this.settings.widgetMainButtonBackground}} !important;
            color: {{this.settings.widgetMainButtonColor}} !important;
          }
          .text-primary {
            color: {{this.settings.widgetMainButtonBackground}} !important;
          }
          .btn-default,.border-primary{
            border-color:{{this.settings.widgetMainButtonBackground}} !important;
          }
        </v-style>
        <router-view></router-view>
    </div>
    <div v-else class="text-center">
      <div class="spinner-border text-center" style="width: 3rem; height: 3rem;" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
<!--     <div id="general-spinner">
        <div class="spinner-border text-center" role="status">
          <span class="sr-only">Loading...</span>
        </div>
    </div>
 -->  </div>
</template>

<script>
import { setOptions, bootstrap } from 'vue-gtag'

export default {
  name: 'app',
  components:{
  },
  data: () => {
    return {
      loading: true,
      settings: []
    }
  },
  computed:{
  },
  methods:{
    enableG4(gaId) {
      setOptions({
        config: { id: gaId }
      })
      bootstrap().then(() => {
        this.$store.commit('ga4Plugin',this.$gtag);
      })
    }
  },
  mounted() {
    this.$http.get('settings').then((res) => {
      this.$store.commit('settings', res.body);
      this.settings = res.body;
      this.loading = false;
      if(this.settings.gaId) this.enableG4(this.settings.gaId)
    });
  }
}
</script>

<style scoped>
#app {
  padding-top: 15px;
  padding-bottom: 100px;
  width: 100%;
}
nav .btn-group{
  width: 100%;
}
.container > div{
  margin: 0 auto;
  max-width: 850px;
}
</style>

<style>
#general-spinner{
  z-index: 9999;
  top: 0;
  left: 0;
  align-items: center;
  justify-content: center;
  position: fixed;
  display: flex;
  width: 100%;
  height: 100%;
  /*background: rgba(255,255,255,.7);*/
  background: #fff;
}
  #companyImage{
    max-width: 200px;
  }
  .btn-default{
    background-color: #fff !important;
  }
  hr{
    margin-top: .5rem;
    margin-bottom: .5rem;
  }
  .btn-selection label.active svg.check{
    display: block;
  }
  .btn-selection label svg.check{
    display:none;
    position: absolute;
    top: 5px;
    right:5px;
    border-radius: 100%;
    padding: 2px;
  }
  .btn-selection label.active{
    /*width: 32%;*/
    height: 100px;
  }
  .btn-selection{
    width: 100%;
    align-items: center;
    justify-content: center;
  }
  .btn-selection label input{
    visibility: hidden;
    position: absolute;
  }
  .btn-selection label{
    border-width: 3px;
    border-style: solid;
    /*white-space:nowrap;*/
    font-weight: bold;
    position: relative;
    /*width: 33.3%;*/
    line-height: 18px;
    height: 80px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 .5px !important;
  }
</style>
